import { Layout } from '@/features/layout/types'
import { RootState } from '@/redux/store'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Dimensions, ScaledSize } from 'react-native'

interface ScreenState {
    orientation: 'portrait' | 'landscape'
    size: 'small' | 'large'
    layout: Layout
    width: number
}

const largeScreenMinLargestDimension = 1024

export const getScreenState = (windowScaledSize: ScaledSize): ScreenState => {
    const { width, height } = windowScaledSize

    const orientation = width < height ? 'portrait' : 'landscape'

    const largestDimension = Math.max(width, height)
    const size = largestDimension < largeScreenMinLargestDimension ? 'small' : 'large'

    return {
        orientation,
        size,
        layout: size === 'small' || orientation === 'portrait' ? 'compact' : 'extended',
        width,
    }
}

export const initialState: ScreenState = getScreenState(Dimensions.get('window'))

const screenSlice = createSlice({
    name: 'screen',
    initialState,
    reducers: {
        setScreen: (_, { payload: window }: PayloadAction<ScaledSize>) => getScreenState(window),
    },
})

export const { setScreen } = screenSlice.actions

export const screenSelectors = {
    orientation: ({ screen }: RootState) => screen.orientation,
    size: ({ screen }: RootState) => screen.size,
    layout: ({ screen }: RootState) => screen.layout,
    width: ({ screen }: RootState) => screen.width,
}

export default screenSlice.reducer
